import { render, staticRenderFns } from "./PlanNeeds.vue?vue&type=template&id=738f3a45&scoped=true"
import script from "./PlanNeeds.vue?vue&type=script&lang=js"
export * from "./PlanNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738f3a45",
  null
  
)

export default component.exports